import { useMutation } from "@tanstack/react-query";
import { useNotification, useTranslate } from "@refinedev/core";

import { ApiError } from "@shared/types";
import { PromocodeBatch } from "@modules/promocodeBatches/types";
import { PromocodeBatchFormValues } from "@modules/promocodeBatches/validations";

import { editPromocodeBatchService } from "./service";
import { UseEditPromocodeBatchMutationOptions } from "./types";

export function useEditPromocodeBatchMutation(
  options?: UseEditPromocodeBatchMutationOptions
) {
  const { open } = useNotification();
  const translate = useTranslate();

  return useMutation<PromocodeBatch, ApiError, { id: string; data: PromocodeBatchFormValues }>({
    mutationFn: ({ id, data }) => editPromocodeBatchService(id, data),
    onSuccess: () => {
      open?.({
        type: "success",
        message: translate("promocode_batch_admin.success.edit"),
      });
    },
    onError: (error: ApiError) => {
      open?.({
        type: "error",
        message: error.response.data.error,
      });
    },
    ...options,
  });
}
